import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a43a5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "cont",
  id: "cont"
}
const _hoisted_2 = { class: "hello" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "40",
  src: "logo.png"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hello from hyperchessbotauthor !!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Welcome to my Vue JS Chessboard ...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Log into lichess, make moves, draw circles and arrows, change board size and flip if necessary, when ready press Export to create a screenshot, then either press Download to save the screenshot locally or Upload to get a GitHub share link ", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Svg ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Svg = _resolveComponent("Svg")!
  const _component_ChessboardExt = _resolveComponent("ChessboardExt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.welcome)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.test)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_7,
            _createVNode(_component_Svg)
          ], 64))
        : (_openBlock(), _createBlock(_component_ChessboardExt, {
            key: 2,
            size: 480,
            onChessboardmoveplayed: _ctx.event
          }, null, 8, ["onChessboardmoveplayed"]))
    ])
  ], 512))
}